// Mobile menu
(function() {
  const menu = document.querySelector('[data-mobile-menu]');
  if (!menu) return;

  function open() {
    menu.hidden = false;
    requestAnimationFrame(() => {
      menu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    });
  }

  function close() {
    menu.classList.remove('is-open');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    setTimeout(() => { menu.hidden = true; }, 300);
  }

  // Toggle button
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-mobile-menu-toggle]')) {
      e.preventDefault();
      open();
    }
    if (e.target.closest('[data-mobile-menu-close]')) {
      close();
    }
  });

  // Accordion
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-mobile-accordion]');
    if (!btn) return;

    const isOpen = btn.getAttribute('aria-expanded') === 'true';
    const submenu = btn.nextElementSibling;

    btn.setAttribute('aria-expanded', !isOpen);
    if (submenu) submenu.hidden = isOpen;
  });

  // Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
  });
})();
